import{ useState } from "react";
import { useSearchParams } from 'react-router-dom';

import userApi from "../../api/userApi";
import unitApi from "../../api/unitApi";
import roleApi from "../../api/roleApi";
import useMount from "../../hooks/useMount";
import AlertModal from "../Commons/AlertModal";
import ActionButton from "../Commons/ActionButton";
import UserModal from "./UserModal";
import ListComponent from "../Commons/ListComponent";
import Pagination from "../Commons/Pagination";
import ListFilter from "../Commons/ListFilter";
import { applyListFilter, applyListSort, applyListFilterAndSort, formatUTCToLocal } from "../../tools/GeneralHelper";

import { getLabel, getLanguage } from "../../tools/Dictionary";


import { MdRefresh } from "react-icons/md";



const UserCont = (props) =>
{

  //Query
  let [searchParam, setSearchParam] = useSearchParams();

  

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ParentLoading = props.ParentLoading;
  const setParentLoading = props.setParentLoading;


  //State
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState([]);
  const [role, setRole] = useState([]);
  const [temperatureUnit, setTemperatureUnit] = useState([]);
  const [currentUser, setCurrentUser] = useState([]);
  const [column, setColumn] = useState([
    {
      label: getLabel("T_User", "email"),
      property: "email",
      style: { width: "22%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "30%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_User", "firstName"),
      property: "firstName",
      style: { width: "12%", minWidth: "100px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_User", "lastName"),
      property: "lastName",
      style: { width: "12%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_User", "companyName"),
      property: "companyName",
      style: { width: "15%", minWidth: "50px" },
      isMobile: false,
      mobileStyle: { width: "15%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_User", "role"),
      property: "role.label",
      style: { width: "8%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "20%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: ""
    },
    {
      label: getLabel("T_User", "isValid"),
      property: "isValid",
      style: { width: "9%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: "",
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
    },
    {
      label: getLabel("T_User", "isActive"),
      property: "isActive",
      style: { width: "7%", minWidth: "50px" },
      isMobile: true,
      mobileStyle: { width: "10%", minWidth: "50px" },
      filterOperator: "like",
      filterValue: "",
      format: "boolean",
      booleanValue: { true: getLabel("App", "Yes"), false: getLabel("App", "No") },
    },
    {
      label: getLabel("T_User", "lastLoginAt"),
      property: "lastLoginAt",
      style: { width: "14%", minWidth: "50px" },
      isMobile: false,
      filterOperator: "like",
      filterValue: ""
    }
  ]);
  const [sort, setSort] = useState({
    property: "",
    direction: 0 // Desc = 0, Asc = 1
  });
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10
  });
  const [modal, setModal] = useState({
    id: 0,
    display: false
  });
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  // // //Test
  // // let test = 0;
  // // column.forEach(c => {
  // //   test += parseFloat(c.style.width.slice(0, -1))
  // //   test += parseFloat(c.style.width.slice(0, -1))
  // // });

  // console.log(test)

  useMount(() =>
  {

    const firstLoad = async() => {

      await loadData();


      if (searchParam.get('_id')){
        setModal({
          id: searchParam.get('_id'),
          display: true
        });
        setSearchParam({});
      }
      
    };

    firstLoad();


  }, []);


  const loadData = async (_showLoading = true) =>
  {

    try
    {

      if (_showLoading)
      {
        setParentLoading(true);
        setLoading(true);
      }

      let [userData, temperatureUnitData, roleData] = await Promise.all([
        userApi.getUsers({ select: `_id,email,firstName,lastName,companyName,role.label,isValid,isVerified,isLocked,isActive,lastLoginAt`, sort: "createdAt desc", translate: getLanguage().code }),
        unitApi.getUnits({ filter: "group eq 'Temperature'", select: `_id,label`, translate: getLanguage().code }),
        roleApi.getRoles({ select: `_id,label,displayOrder`, translate: getLanguage().code, sort: "displayOrder asc", }),
      ]);

      if (userData.Success)
      {
        let loadedUser = applyListFilterAndSort(userData.Data, column, sort);

        loadedUser = loadedUser.map(user => ({
          ...user,
          lastLoginAt: formatUTCToLocal(user.lastLoginAt)
        }));

        setUser(loadedUser);
        checkDataUpdateForPagination(loadedUser, pagination);


      } else
        throw new Error(userData.Error.label);

      if (temperatureUnitData.Success)
      {
        setTemperatureUnit(temperatureUnitData.Data);
      } else
        throw new Error(temperatureUnitData.Error.label);

      if (roleData.Success)
      {
        setRole(roleData.Data);
      } else
        throw new Error(roleData.Error.label);



      setParentLoading(false);
      setLoading(false);

    } catch (err)
    {

      setParentLoading(false);
      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  const checkDataUpdateForPagination = (_data, _pagination, _resetPage = false) =>
  {

    let tempData = _data.filter(d => !d.bFiltered);
    let maxPage = Math.ceil(tempData.length / _pagination.perPage);
    let currentPage = _pagination.page;

    if (_resetPage)
      currentPage = 1;
    else if (_pagination.page > maxPage)
    {
      currentPage = maxPage > 0 ? maxPage : 1;
    }

    setCurrentUser(sliceDataForPagination(_data, currentPage));

    setPagination(pagination => ({
      ...pagination,
      page: currentPage
    }));
  };

  const sliceDataForPagination = (_data, _page) =>
  {

    return _data.filter(d => !d.bFiltered).slice(pagination.perPage * (_page - 1), pagination.perPage * (_page - 1) + pagination.perPage);

  };

  const onClickSort = (_sort) =>
  {

    let tempData = applyListSort(user, _sort);

    setUser(tempData);
    checkDataUpdateForPagination(tempData, pagination);
    setSort(_sort);

  };

  const onApplyFilter = (_column) =>
  {

    let tempData = applyListFilter(user, _column);

    setUser(tempData);
    checkDataUpdateForPagination(tempData, pagination, true);
    setColumn(_column);

  };



  const onChangePage = (_page) =>
  {

    let tempPagination = {
      ...pagination,
      page: _page
    };

    checkDataUpdateForPagination(user, tempPagination);

  };


  // const onClickNew = () => {

  //   setModal({
  //     id: 0,
  //     display: true
  //   });

  // }

  const onClickItem = (_item) =>
  {

    setModal({
      id: _item._id,
      display: true
    });

  };


  let currentLoading = loading || ParentLoading;


  return (
    <div className="page_body_cont">
      {modal.display &&
        <UserModal
          IsDesktop={IsDesktop}
          Id={modal.id}
          TemperatureUnit={temperatureUnit}
          Role={role}
          Access={Access}
          OnCloseModal={() => setModal({ id: 0, display: false })}
          LoadData={() => loadData(false)}
        />
      }
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <div className="page_action_cont" style={{ width: "90%", maxWidth: "1200px" }}>
        <div className="page_action_section" style={{ width: "15%" }}>
          {/* <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("App", "New")}
            Icon={MdAdd}
            Disabled={currentLoading}
            OnClick={onClickNew}
          /> */}
        </div>
        <div className="page_action_section" style={{ width: "15%" }}>
          <ActionButton
            IsDesktop={IsDesktop}
            Label={getLabel("App", "Refresh")}
            Icon={MdRefresh}
            Disabled={currentLoading}
            OnClick={loadData}
          />
        </div>
        <div className="page_action_section" style={{ width: "40%", justifyContent: "center" }}>
          <Pagination
            IsDesktop={IsDesktop}
            data={pagination}
            onChangePage={onChangePage}
            count={user.filter(p => !p.bFiltered).length}
          />
        </div>
        <div className="page_action_section" style={{ width: "30%", justifyContent: "right" }}>
          <ListFilter
            IsDesktop={IsDesktop}
            column={column}
            Data={user}
            OnApplyFilter={onApplyFilter}
          />
        </div>
      </div>

      <ListComponent
        IsDesktop={IsDesktop}
        Column={column}
        Data={currentUser}
        Sort={sort}
        ListStyle={{ width: "90%", maxWidth: "1200px" }}
        Loading={loading}
        Debug={false}
        OnClickSort={onClickSort}
        OnClickItem={onClickItem}
      />

    </div>
  );

}


export default UserCont;